const formatDate = (date) => {
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };
    return new Intl.DateTimeFormat(undefined, options).format(date);
};

const formatTime = (date) => {
    const options = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    };
    return new Intl.DateTimeFormat(undefined, options).format(date);
};

export const convertEpochToDateTime = (epochNS) => {
    const date = new Date(epochNS / 1000000); // Convert nanoseconds to milliseconds
    return {
        date: formatDate(date),
        time: formatTime(date)
    };
};

/**
 * Format epoch nanoseconds to a combined date/time string
 * @param {number} epochNS - Epoch time in nanoseconds
 * @returns {string} - Formatted date/time string or empty string if invalid
 */
export const formatEpochToString = (epochNS) => {
    if (!epochNS) return '';
    const dt = convertEpochToDateTime(epochNS);
    return `${dt.date} ${dt.time}`;
};

/**
 * Format duration in seconds to a human-readable string
 * @param {number} seconds - Duration in seconds
 * @param {object} options - Formatting options
 * @param {boolean} options.showMilliseconds - Show milliseconds for short durations (default: false)
 * @returns {string} - Formatted duration string (e.g., "1m 23s", "45.2s")
 */
export const formatDuration = (seconds, options = {}) => {
    if (seconds === null || seconds === undefined) return '';
    
    const { showMilliseconds = false } = options;
    const absSeconds = Math.abs(seconds);
    
    if (absSeconds >= 3600) {
        // 1 hour or more: show hours and minutes
        const hours = Math.floor(absSeconds / 3600);
        const mins = Math.floor((absSeconds % 3600) / 60);
        return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
    } else if (absSeconds >= 60) {
        // 1 minute or more: show minutes and seconds
        const mins = Math.floor(absSeconds / 60);
        const secs = Math.floor(absSeconds % 60);
        return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`;
    } else if (absSeconds >= 10) {
        // 10 seconds or more: show with 1 decimal
        return `${absSeconds.toFixed(1)}s`;
    } else if (showMilliseconds && absSeconds < 1) {
        // Less than 1 second with milliseconds option
        return `${(absSeconds * 1000).toFixed(0)}ms`;
    } else {
        // Less than 10 seconds: show with 2 decimals
        return `${absSeconds.toFixed(2)}s`;
    }
};